import BtnActivity from './BtnActivity';
export default BtnActivity;
